import * as React from 'react';
import { CardSkeletonContainer, LoadingImageContainer, Footer, LoadingText } from './ProductCardSkeleton.styles.js';

var ProductCardSkeleton = function () {
    return (React.createElement(CardSkeletonContainer, { "aria-label": "ProductCardSkeleton" },
        React.createElement(LoadingImageContainer, null),
        React.createElement(Footer, null,
            React.createElement(LoadingText, { width: "80%" }),
            React.createElement(LoadingText, { width: "80%" }),
            React.createElement(LoadingText, { width: "60%" }),
            React.createElement("br", null),
            React.createElement(LoadingText, { width: "50%" }))));
};

export { ProductCardSkeleton as default };
//# sourceMappingURL=ProductCardSkeleton.js.map
